var styleDataHash = "df4abe38";
const injectCss = () => {
  var css = `.r4Buc{box-sizing:border-box;display:flex;flex-direction:column;width:162px;z-index:10}[dir] .r4Buc{background-color:#fff}.r4Buc *,.r4Buc :after,.r4Buc :before{box-sizing:inherit}.r4Buc input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.r4Buc{width:100%}}}@container (width < 640px){.r4Buc{width:100%}}._5QmJ6{align-items:flex-start;align-items:center;display:flex;flex-direction:column;width:100%}[dir] ._5QmJ6{padding:8px 0}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var DropdownModal_default = {
  "modal": "r4Buc",
  "dropdownModalOptionsWrapper": "_5QmJ6"
};
export {
  DropdownModal_default as default,
  injectCss
};
//# sourceMappingURL=DropdownModal-scss.js.map
